import List from '@mui/material/List';
import { styled } from '@mui/material/styles';
import {
  getRequests,
  getDispatcherRequests,
  getCloneRequests,
} from 'app/main/Requests/store/requestsSlice';
import clsx from 'clsx';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FuseNavItem from '../FuseNavItem';
import store from '../../../../app/main/ID_store/store';
import AuthReducer from 'app/stores/loadz/redux/Auth/index';
import { connect } from 'react-redux';
import { injectReducer } from 'app/store';
import { useHistory } from 'react-router-dom';
import client from 'client';
import { motion } from 'framer-motion';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Button, Grid, IconButton, Paper, Typography } from '@mui/material';
import { PERMISSION_MODEL } from '../../../../constants';
import { hasPermission } from 'app/main/loadz/utils';
import JobReducer from 'app/stores/loadz/redux/Jobs';
import JobAction from 'app/stores/loadz/redux/Jobs/actions';
import { useSocket } from 'app/SocketContext';
import {useTranslation} from 'react-i18next';
import {
  getCachedSubscriptionCounter,
  saveCachedSubscriptionCounter,
  getCachedSubscriptionCompany,
  saveCachedSubscriptionCompany,
} from 'app/main/Dashboard/dashboardFetchCache';
import { fetchPaymentProviderFlags } from 'app/main/Dwolla/paymentProviders';

const moment = require('moment');

// Cache a nivel de módulo: no repetir GET /company/:user_id al remontar (p. ej. cambio de layout por resize)
const companyFetchedUserIds = new Set();

// Clave de última ejecución de callApiChangeNavigation: evita refetch al redimensionar o remontar (mismo compacctnum + request_load)
let lastNavFetchKey = null;

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(16),
    border: '1px solid #dadde9',
  },
}));

const StyledList = styled(List)(({ theme }) => ({
  '& .fuse-list-item': {
    '&:hover': {
      backgroundColor:
        theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0,0,0,.04)',
    },
    '&:focus:not(.active)': {
      backgroundColor:
        theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.06)' : 'rgba(0,0,0,.05)',
    },
  },
  '&.active-square-list': {
    '& .fuse-list-item, & .active.fuse-list-item': {
      width: '100%',
      borderRadius: '0',
    },
  },
  '&.dense': {
    '& .fuse-list-item': {
      paddingTop: 0,
      paddingBottom: 0,
      height: 32,
    },
  },
}));

function FuseNavVerticalLayout1({
  navigation,
  layout,
  active,
  dense,
  className,
  onItemClick,
  company,
  user,
  getPendingJobs,
  pending_jobs_count,
  bol_pending_count,
  getBolPendingCount,
  navRequestCount = 0,
}) {
  // request_load: array que cambia cuando el usuario pide recargar; usamos longitud (primitivo) para no disparar efecto en cada actualización de Redux
  const request_load = useSelector(({ requests }) => requests?.request?.request_load ?? requests?.request_load);
  const requestLoadLength = request_load?.length ?? 0;
  const dispatch = useDispatch();
  const history = useHistory();
  const [ActiveStep, setActiveStep] = useState(null);
  const [enableUsioEnrollment, setEnableUsioEnrollment] = useState(true);
  const [counterDriver, setCounterDriver] = useState(null);
  const [counterSub, setCounterSub] = useState(null);
  const [counterOwner, setCounterOwner] = useState(null);
  const [counterUser, setCounterUser] = useState(null);
  const [newNavigation, setNewNavigation] = useState([]);
  const [daysRemaining, setDaysRemaining] = useState(null);
  const [hidden, setHidden] = useState(true);
  const [open, setOpen] = useState(false);
  let { comp_acct } = store.getState();
  
  // Cache para evitar llamadas repetidas
  const lastFetchTimeRef = useRef({
    counterUsers: 0,
    subscriptionCompany: 0
  });
  const CACHE_DURATION = 30000; // 30 segundos de cache

  // Evitar state updates después de unmount (memory leak)
  const isMountedRef = useRef(true);

  const { socket } = useSocket();

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const handleBolCounter = useRef();

  const handleColCounterEvent = async (data) => {
    if (bol_pending_count != JSON.parse(data).count) {
      await getBolPendingCount({ compacctnum: company?.compacctnum }, (error) => {
        console.log('Error getting BOL pending count at nav bar after socket call: ', error);
      });
    }
  };

  handleBolCounter.current = handleColCounterEvent;

  useEffect(() => {
    if (!socket) return;

    const bolCounterListener = (data) => handleBolCounter.current(data);

    socket.on('from_server_bol', bolCounterListener);

    return () => {
      if (socket) {
        socket.off('from_server_bol', bolCounterListener);
      }
    };
  }, [socket]);

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
  };

  function handleItemClick(item) {
    onItemClick?.(item);
  }

  // Ref para el debounce de callApiChangeNavigation
  const navigationDebounceRef = useRef(null);
  const lastNavigationFetchRef = useRef(0);
  const NAVIGATION_CACHE_DURATION = 5000; // 5 segundos
  const navigationExecutingRef = useRef(false); // Flag para prevenir ejecuciones concurrentes
  const callApiChangeNavigationRef = useRef(null);
  const lastFetchedCompanyUserIdRef = useRef(null);

  const callApiChangeNavigation = useCallback(async () => {
    if (!navigation || navigation.length === 0) {
      return;
    }

    // Verificar cache
    const now = Date.now();
    if (now - lastNavigationFetchRef.current < NAVIGATION_CACHE_DURATION) {
      console.log('⏭️ Skipping callApiChangeNavigation - too soon (cache active)');
      return;
    }

    // Si ya está ejecutándose, no ejecutar de nuevo
    if (navigationExecutingRef.current) {
      console.log('⏭️ Skipping callApiChangeNavigation - already running');
      return;
    }

    // Cancelar timeout anterior
    if (navigationDebounceRef.current) {
      clearTimeout(navigationDebounceRef.current);
    }

    // Agregar debounce
    navigationDebounceRef.current = setTimeout(async () => {
      navigationExecutingRef.current = true;
      try {
        const currentComp = comp_acct || company?.compacctnum;
        if (!currentComp) return;

        console.log('🔄 Executing callApiChangeNavigation...');

        const getApiRes = await dispatch(getRequests(currentComp));
        const getApiDisRes = await dispatch(getDispatcherRequests(currentComp));
        const getApiCloneRes = await dispatch(getCloneRequests(currentComp));
        await getPendingJobs({ compacctnum: currentComp }, (error) => {
          console.log('Error getting pending jobs at nav bar: ', error);
        });
        await getBolPendingCount({ compacctnum: currentComp }, (error) => {
          console.log('Error getting BOL pending count at nav bar: ', error);
        });

        let count = 0;
        let dis_count = 0;
        let clone_count = 0;
        if (
          getApiRes &&
          getApiRes.payload &&
          getApiRes.payload.requests &&
          getApiRes.payload.requests.length > 0
        ) {
          count = getApiRes.payload.requests.filter((obj) => !obj.resolved).length;
        }
        if (
          getApiDisRes &&
          getApiDisRes.payload &&
          getApiDisRes.payload.requests &&
          getApiDisRes.payload.requests.length > 0
        ) {
          dis_count = getApiDisRes.payload.requests.filter((obj) => !obj.resolved).length;
        }
        if (
          getApiCloneRes &&
          getApiCloneRes.payload &&
          getApiCloneRes.payload.requests &&
          getApiCloneRes.payload.requests.length > 0
        ) {
          clone_count = getApiCloneRes.payload.requests.filter((obj) => !obj.resolved).length;
        }
        count = count + dis_count + clone_count;
        let newArray = [];
        for (const _item of navigation) {
          let obj = { ..._item };
          if (obj?.children && obj?.children.length > 0) {
            obj?.children.forEach((childItem) => {
              if (childItem?.id == 'dashboard') {
                if (count > 0) {
                  childItem.countofPending = { title: count, bg: 'red', fg: 'white' };
                } else {
                  childItem.countofPending = null;
                }
              }
              if (childItem?.id == 'jobs') {
                if (pending_jobs_count > 0) {
                  childItem.countofPending = { title: pending_jobs_count, bg: 'red', fg: 'white' };
                } else {
                  childItem.countofPending = null;
                }
              }

              if (childItem?.id == 'customers') {
                if (bol_pending_count > 0) {
                  childItem.countofPending = { title: bol_pending_count, bg: 'red', fg: 'white' };
                } else {
                  childItem.countofPending = null;
                }
              }

              if (childItem?.children && childItem?.children.length > 0) {
                const children = childItem?.children.map((c) => {
                  const countofPending =
                    c.id == 'requests'
                      ? { title: count, bg: 'red', fg: 'white' }
                      : c.id == 'jobs_drafts'
                      ? { title: pending_jobs_count, bg: 'red', fg: 'white' }
                      : null;
                  return { ...c, countofPending };
                });
                childItem.children = children;
              }
            });
          }
          newArray.push(obj);
        }
        if (!isMountedRef.current) return;
        setNewNavigation(newArray);
        setReloadBar((prev) => !prev);
        lastNavigationFetchRef.current = Date.now();
      } catch (error) {
        console.error('Error in callApiChangeNavigation:', error);
      } finally {
        navigationExecutingRef.current = false;
      }
    }, 500); // 500ms de debounce
  }, [navigation, company?.compacctnum, pending_jobs_count, bol_pending_count, dispatch, getPendingJobs, getBolPendingCount]);

  callApiChangeNavigationRef.current = callApiChangeNavigation;

  // Construir newNavigation solo con datos actuales (sin peticiones). Usado cuando se salta el refetch (resize/remount).
  const buildNavigationFromCounts = useCallback(
    (nav, count, pendingJobs, bolCount) => {
      if (!nav || nav.length === 0) return [];
      const newArray = [];
      for (const _item of nav) {
        const obj = { ..._item };
        if (obj?.children && obj?.children.length > 0) {
          obj?.children?.forEach((childItem) => {
            if (childItem?.id === 'dashboard') {
              childItem.countofPending = count > 0 ? { title: count, bg: 'red', fg: 'white' } : null;
            }
            if (childItem?.id === 'jobs') {
              childItem.countofPending = pendingJobs > 0 ? { title: pendingJobs, bg: 'red', fg: 'white' } : null;
            }
            if (childItem?.id === 'customers') {
              childItem.countofPending = bolCount > 0 ? { title: bolCount, bg: 'red', fg: 'white' } : null;
            }
            if (childItem?.children && childItem?.children.length > 0) {
              childItem.children = childItem.children.map((c) => ({
                ...c,
                countofPending:
                  c.id === 'requests'
                    ? { title: count, bg: 'red', fg: 'white' }
                    : c.id === 'jobs_drafts'
                    ? { title: pendingJobs, bg: 'red', fg: 'white' }
                    : null,
              }));
            }
          });
        }
        newArray.push(obj);
      }
      return newArray;
    },
    []
  );

  // Solo ejecutar cuando cambie compacctnum o requestLoadLength (toggle de "recargar"). No ejecutar en resize/remount.
  const compacctnum = company?.compacctnum;
  useEffect(() => {
    if (!compacctnum) return;
    const fetchKey = `${compacctnum}_${requestLoadLength}`;
    if (lastNavFetchKey === fetchKey) {
      // Misma clave: no refetch, pero sí construir el menú con datos actuales (Redux/props) para que se vea al remount (resize).
      const menuItems = buildNavigationFromCounts(
        navigation,
        navRequestCount,
        pending_jobs_count ?? 0,
        bol_pending_count ?? 0
      );
      if (menuItems.length > 0) {
        setNewNavigation(menuItems);
        setReloadBar((prev) => !prev);
      }
      return;
    }
    lastNavFetchKey = fetchKey;
    callApiChangeNavigationRef.current?.();

    return () => {
      if (navigationDebounceRef.current) {
        clearTimeout(navigationDebounceRef.current);
      }
    };
  }, [compacctnum, requestLoadLength]);

  const dwollaClick = () => {
    if (user?.user_id) {
      history.replace(`/dwolla/intro`);
    }
  };

  const counterUsersRef = useRef(null);
  const subscriptionCompanyRef = useRef(null);
  const counterUsersExecutingRef = useRef(false);
  const subscriptionCompanyExecutingRef = useRef(false);

  const counterUsers = useCallback(async () => {
    if (!company?.compacctnum) {
      return;
    }

    // Si ya está ejecutándose, no ejecutar de nuevo
    if (counterUsersExecutingRef.current) {
      console.log('⏭️ Skipping counterUsers - already running');
      return;
    }
    
    // Intentar cargar desde cache primero
    const cachedData = getCachedSubscriptionCounter(company.compacctnum);
    if (cachedData) {
      console.log('✅ Using cached subscription counter');
      if (!isMountedRef.current) return;
      setCounterDriver(cachedData.driverCount);
      setCounterOwner(cachedData.ownerCountDrivers.sum);
      setCounterSub(cachedData.subCount);
      setCounterUser(cachedData.usersCount);
      return;
    }
    
    // Cancelar la llamada anterior si existe
    if (counterUsersRef.current) {
      clearTimeout(counterUsersRef.current);
    }
    
    // Agregar un pequeño delay para evitar llamadas múltiples
    counterUsersRef.current = setTimeout(async () => {
      counterUsersExecutingRef.current = true;
      try {
        console.log('🔄 Fetching subscription counter...');
        const result = await client.post(`/subscription/subscription-counter/${company?.compacctnum}`);
        const data = result.data;
        
        // Guardar en cache
        saveCachedSubscriptionCounter(company.compacctnum, data);
        
        // Actualizar estado solo si el componente sigue montado
        if (!isMountedRef.current) return;
        setCounterDriver(data.driverCount);
        setCounterOwner(data.ownerCountDrivers.sum);
        setCounterSub(data.subCount);
        setCounterUser(data.usersCount);
        lastFetchTimeRef.current.counterUsers = Date.now();
      } catch (error) {
        console.log('Error fetching subscription counter:', error);
      } finally {
        counterUsersExecutingRef.current = false;
      }
    }, 300);
  }, [company?.compacctnum]);

  const subscriptionCompany = useCallback(async () => {
    if (!company?.compacctnum) {
      return;
    }

    // Si ya está ejecutándose, no ejecutar de nuevo
    if (subscriptionCompanyExecutingRef.current) {
      console.log('⏭️ Skipping subscriptionCompany - already running');
      return;
    }
    
    // Intentar cargar desde cache primero
    const cachedData = getCachedSubscriptionCompany(company.compacctnum);
    if (cachedData) {
      console.log('✅ Using cached subscription company');
      if (!isMountedRef.current) return;
      setHidden(cachedData.status === 'ontrial');
      setDaysRemaining(cachedData.daysRemaining);
      return;
    }
    
    // Cancelar la llamada anterior si existe
    if (subscriptionCompanyRef.current) {
      clearTimeout(subscriptionCompanyRef.current);
    }
    
    subscriptionCompanyRef.current = setTimeout(async () => {
      subscriptionCompanyExecutingRef.current = true;
      try {
        console.log('🔄 Fetching subscription company...');
        const response = await client.get(
          `/subscription/subscription-company/${company?.compacctnum}`
        );

        const isOnTrial = response.data[0].status === 'ontrial';
        const start = moment(response.data[0].trial_start);
        const trialDuration = response.data[0].days_of_trial_period_comp
          ? response.data[0].days_of_trial_period_comp
          : response.data[0].days_of_trail_period;
        const now = moment();
        const endOfTrial = start.clone().add(trialDuration, 'days');
        const daysRemaining = endOfTrial.diff(now, 'days');
        if (!isMountedRef.current) return;
        setHidden(isOnTrial);
        setDaysRemaining(daysRemaining);
        
        // Guardar en cache
        saveCachedSubscriptionCompany(company.compacctnum, {
          status: response.data[0].status,
          daysRemaining,
        });
        
        lastFetchTimeRef.current.subscriptionCompany = Date.now();
      } catch (error) {
        console.log(error);
        if (isMountedRef.current) setHidden(false);
      } finally {
        subscriptionCompanyExecutingRef.current = false;
      }
    }, 300);
  }, [company?.compacctnum]);

  const counterUsersFnRef = useRef(counterUsers);
  const subscriptionCompanyFnRef = useRef(subscriptionCompany);
  counterUsersFnRef.current = counterUsers;
  subscriptionCompanyFnRef.current = subscriptionCompany;

  // Solo ejecutar cuando cambie user_id. No depender de counterUsers/subscriptionCompany para evitar re-ejecución en cada re-render (resize).
  useEffect(() => {
    if (!user?.user_id) return;
    async function handleSave() {
      if (companyFetchedUserIds.has(user.user_id)) return;
      companyFetchedUserIds.add(user.user_id);
      lastFetchedCompanyUserIdRef.current = user.user_id;
      try {
        const [result, providerFlags] = await Promise.all([
          client.get(`/company/${user?.user_id}`),
          fetchPaymentProviderFlags(user?.user_id),
        ]);
        if (!isMountedRef.current) return;
        setActiveStep(result.data.types_steps_checkouts_id);
        setEnableUsioEnrollment(providerFlags.enable_usio !== false);
      } catch (error) {
        companyFetchedUserIds.delete(user.user_id);
        lastFetchedCompanyUserIdRef.current = null;
        console.log('Error fetching company data:', error);
      }
    }
    handleSave();
    counterUsersFnRef.current?.();
    subscriptionCompanyFnRef.current?.();

    return () => {
      if (counterUsersRef.current) clearTimeout(counterUsersRef.current);
      if (subscriptionCompanyRef.current) clearTimeout(subscriptionCompanyRef.current);
      if (navigationDebounceRef.current) clearTimeout(navigationDebounceRef.current);
    };
  }, [user?.user_id]);

  const managePaymentMethods = async () => {
    history.push('/subscriptions-company');
  };

  const [reloadBar, setReloadBar] = useState(false);

  const handleReloadBar = useCallback(() => {
    return( <div>
      <StyledList
        className={clsx(
          'navigation whitespace-nowrap px-12',
          `active-${active}-list`,
          dense && 'dense',
          className
        )}
      >
        {newNavigation.map((_item) => (
          <React.Fragment key={_item.id}>
            {_item.tooltip ? (
              <div style={{ position: 'relative' }}>
                <FuseNavItem
                  type={`vertical-${_item.type}`}
                  item={_item}
                  nestedLevel={0}
                  onItemClick={handleItemClick}
                  request_load={request_load}
                />
                <HtmlTooltip
                  title={_item.tooltip}
                  style={{ position: 'absolute', right: 0, top: 0 }}
                >
                  <IconButton>
                    <InfoOutlinedIcon sx={{ color: 'black' }} />
                  </IconButton>
                </HtmlTooltip>

                {_item.id == 'subcontractors-new' && counterSub > 0 && (
                  <IconButton style={{ position: 'absolute', right: 25, top: 3 }}>
                    <div className='item-badge px-3 bg-black text-white rounded-full text-xs'>
                      {counterSub}
                    </div>
                  </IconButton>
                )}

                {_item.id == 'owner-operators' && counterOwner > 0 && (
                  <IconButton style={{ position: 'absolute', right: 25, top: 3 }}>
                    <div className='item-badge px-3 bg-black text-white rounded-full text-xs'>
                      {counterOwner}
                    </div>
                  </IconButton>
                )}

                {_item.id == 'dispatch' && (
                  <span
                    className='item-badge bg-black text-xs  rounded-full px-2 py-1'
                    style={{
                      position: 'absolute',
                      right: 118,
                      top: 18,
                      color: '#edca33',
                      paddingLeft: '5px',
                      paddingRight: '5px',
                    }}
                  >
                    Beta
                  </span>
                )}

                {_item.id == 'agent' && (
                  <span
                    className='item-badge bg-black text-xs  rounded-full px-2 py-1'
                    style={{
                      position: 'absolute',
                      right: 118,
                      top: 18,
                      color: '#edca33',
                      paddingLeft: '5px',
                      paddingRight: '5px',
                    }}
                  >
                    Beta
                  </span>
                )}
              </div>
            ) : (
              <>
                <div style={{ position: 'relative' }}>
                  <FuseNavItem
                    key={_item.id}
                    type={`vertical-${_item.type}`}
                    item={_item}
                    nestedLevel={0}
                    onItemClick={handleItemClick}
                    request_load={request_load}
                  />
                  {_item.id == 'driverlist' && counterDriver > 0 && (
                    <IconButton style={{ position: 'absolute', right: 25, top: 3 }}>
                      <div className='item-badge px-3 bg-black text-white rounded-full text-xs'>
                        {counterDriver}
                      </div>
                    </IconButton>
                  )}

                  {_item.id == 'stafflist' && counterUser > 0 && (
                    <IconButton style={{ position: 'absolute', right: 25, top: 3 }}>
                      <div className='item-badge px-3 bg-black text-white rounded-full text-xs'>
                        {counterUser}
                      </div>
                    </IconButton>
                  )}

                  {_item.id == 'dispatch' && (
                    <span
                      className='item-badge bg-black text-xs  rounded-full px-2 py-1'
                      style={{
                        position: 'absolute',
                        right: 134,
                        top: 18,
                        color: '#edca33',
                        paddingLeft: '5px',
                        paddingRight: '5px',
                      }}
                    >
                      Beta
                    </span>
                  )}

                  {_item.id == 'agent' && (
                    <span
                      className='item-badge bg-black text-xs  rounded-full px-2 py-1'
                      style={{
                        position: 'absolute',
                        right: 118,
                        top: 18,
                        color: '#edca33',
                        paddingLeft: '5px',
                        paddingRight: '5px',
                      }}
                    >
                      Beta
                    </span>
                  )}
                </div>
              </>
            )}
          </React.Fragment>
        ))}
      </StyledList>

      {user?.user_type != 'super-admin' && hasPermission(PERMISSION_MODEL.fastPayAccess) && (
        <div className='flex flex-col items-center'>
          {hidden ? (
            <Grid className='flex flex-grow  justify-center'>
              <Paper
                style={{
                  marginTop: '20px',
                  padding: '16px',
                  textAlign: 'center',
                  minHeight: '100px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                  borderRadius: '0',
                  backgroundColor: 'transparent', // Fondo transparente
                  border: '1px solid #000', // Borde negro de 1px, ajusta el color como prefieras
                }}
              >
                <Typography variant='h6'>FREE TRIAL ENDS IN</Typography>
                <Typography
                  variant='h2'
                  style={{
                    color: '#FFD700',
                    fontWeight: 'bold',
                    fontSize: '4rem',
                  }}
                >
                  {daysRemaining}
                </Typography>
                <Typography variant='body2'>DAYS</Typography>
                <Button
                  variant='contained'
                  style={{
                    backgroundColor: '#000',
                    color: '#FFF',
                    '&:hover': {
                      backgroundColor: '#333',
                    },
                  }}
                  onClick={() => {
                    managePaymentMethods();
                  }}
                >
                  Update Billing Details
                </Button>
              </Paper>
            </Grid>
          ) : null}

          {enableUsioEnrollment && ActiveStep != 8 ? (
            <>
              <div className='flex pt-40 pb-40'>
                <motion.div variants={item} className='flex flex-row items-center justify-center'>
                  <img
                    onClick={dwollaClick}
                    className='w-4/6 items-center cursor-pointer'
                    src='assets/images/fastpaybanner 2.png'
                    alt='logo'
                  />
                </motion.div>
              </div>
            </>
          ) : null}
        </div>
      )}
    </div>)
  },[reloadBar, enableUsioEnrollment, ActiveStep])

  const {t} = useTranslation('navigation');
  return (
   
      useMemo(() => {
        return(<div>
          <StyledList
            className={clsx(
              'navigation whitespace-nowrap px-12',
              `active-${active}-list`,
              dense && 'dense',
              className
            )}
          >
            {newNavigation.map((_item) => (
              <React.Fragment key={_item.id}>
                {_item.tooltip ? (
                  <div style={{ position: 'relative' }}>
                    <FuseNavItem
                      type={`vertical-${_item.type}`}
                      item={_item}
                      nestedLevel={0}
                      onItemClick={handleItemClick}
                      request_load={request_load}
                    />
                    <HtmlTooltip
                      title={_item.tooltip}
                      style={{ position: 'absolute', right: 0, top: 0 }}
                    >
                      <IconButton>
                        <InfoOutlinedIcon sx={{ color: 'black' }} />
                      </IconButton>
                    </HtmlTooltip>
    
                    {_item.id == 'subcontractors-new' && counterSub > 0 && (
                      <IconButton style={{ position: 'absolute', right: 25, top: 3 }}>
                        <div className='item-badge px-3 bg-black text-white rounded-full text-xs'>
                          {counterSub}
                        </div>
                      </IconButton>
                    )}
    
                    {_item.id == 'owner-operators' && counterOwner > 0 && (
                      <IconButton style={{ position: 'absolute', right: 25, top: 3 }}>
                        <div className='item-badge px-3 bg-black text-white rounded-full text-xs'>
                          {counterOwner}
                        </div>
                      </IconButton>
                    )}
    
                    {_item.id == 'dispatch' && (
                      <span
                        className='item-badge bg-black text-xs  rounded-full px-2 py-1'
                        style={{
                          position: 'absolute',
                          right: 118,
                          top: 18,
                          color: '#edca33',
                          paddingLeft: '5px',
                          paddingRight: '5px',
                        }}
                      >
                        Beta
                      </span>
                    )}
    
                    {_item.id == 'agent' && (
                      <span
                        className='item-badge bg-black text-xs  rounded-full px-2 py-1'
                        style={{
                          position: 'absolute',
                          right: 118,
                          top: 18,
                          color: '#edca33',
                          paddingLeft: '5px',
                          paddingRight: '5px',
                        }}
                      >
                        Beta
                      </span>
                    )}
                  </div>
                ) : (
                  <>
                    <div style={{ position: 'relative' }}>
                      <FuseNavItem
                        key={_item.id}
                        type={`vertical-${_item.type}`}
                        item={_item}
                        nestedLevel={0}
                        onItemClick={handleItemClick}
                        request_load={request_load}
                      />
                      {_item.id == 'driverlist' && counterDriver > 0 && (
                        <IconButton style={{ position: 'absolute', right: 25, top: 3 }}>
                          <div className='item-badge px-3 bg-black text-white rounded-full text-xs'>
                            {counterDriver}
                          </div>
                        </IconButton>
                      )}
    
                      {_item.id == 'stafflist' && counterUser > 0 && (
                        <IconButton style={{ position: 'absolute', right: 25, top: 3 }}>
                          <div className='item-badge px-3 bg-black text-white rounded-full text-xs'>
                            {counterUser}
                          </div>
                        </IconButton>
                      )}
    
                      {_item.id == 'dispatch' && _item.title == 'Despacho' && (
                        <span
                          className='item-badge bg-black text-xs  rounded-full px-2 py-1'
                          style={{
                            position: 'absolute',
                            right: 126,
                            top: 18,
                            color: '#edca33',
                            paddingLeft: '5px',
                            paddingRight: '5px',
                          }}
                        >
                          {t('NEW')}
                        </span>
                      )}

                      {_item.id == 'dispatch' && _item.title == 'Dispatch' && (
                        <span
                          className='item-badge bg-black text-xs  rounded-full px-2 py-1'
                          style={{
                            position: 'absolute',
                            right: 145,
                            top: 18,
                            color: '#edca33',
                            paddingLeft: '5px',
                            paddingRight: '5px',
                          }}
                        >
                          {t('NEW')}
                        </span>
                      )}

                      {_item.id == 'agent' && _item.title == 'Sales Agent' && (
                        <span
                          className='item-badge bg-black text-xs  rounded-full px-2 py-1'
                          style={{
                            position: 'absolute',
                            right: 125,
                            top: 18,
                            color: '#edca33',
                            paddingLeft: '5px',
                            paddingRight: '5px',
                          }}
                        >
                          Beta
                        </span>
                      )}
    
                      {_item.id == 'agent' && _item.title == 'Agente de Ventas' && (
                        <span
                          className='item-badge bg-black text-xs  rounded-full px-2 py-1'
                          style={{
                            position: 'absolute',
                            right: 85,
                            top: 18,
                            color: '#edca33',
                            paddingLeft: '5px',
                            paddingRight: '5px',
                          }}
                        >
                          Beta
                        </span>
                      )}
                    </div>
                  </>
                )}
              </React.Fragment>
            ))}
          </StyledList>
    
          {user?.user_type != 'super-admin' && hasPermission(PERMISSION_MODEL.fastPayAccess) && (
            <div className='flex flex-col items-center'>
              {hidden ? (
                <Grid className='flex flex-grow  justify-center'>
                  <Paper
                    style={{
                      marginTop: '20px',
                      padding: '16px',
                      textAlign: 'center',
                      minHeight: '100px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-around',
                      alignItems: 'center',
                      borderRadius: '0',
                      backgroundColor: 'transparent', // Fondo transparente
                      border: '1px solid #000', // Borde negro de 1px, ajusta el color como prefieras
                    }}
                  >
                    <Typography variant='h6'>FREE TRIAL ENDS IN</Typography>
                    <Typography
                      variant='h2'
                      style={{
                        color: '#FFD700',
                        fontWeight: 'bold',
                        fontSize: '4rem',
                      }}
                    >
                      {daysRemaining}
                    </Typography>
                    <Typography variant='body2'>DAYS</Typography>
                    <Button
                      variant='contained'
                      style={{
                        backgroundColor: '#000',
                        color: '#FFF',
                        '&:hover': {
                          backgroundColor: '#333',
                        },
                      }}
                      onClick={() => {
                        managePaymentMethods();
                      }}
                    >
                      Update Billing Details
                    </Button>
                  </Paper>
                </Grid>
              ) : null}
    
              {enableUsioEnrollment && ActiveStep != 8 ? (
                <>
                  <div className='flex pt-40 pb-40'>
                    <motion.div variants={item} className='flex flex-row items-center justify-center'>
                      <img
                        onClick={dwollaClick}
                        className='w-4/6 items-center cursor-pointer'
                        src='assets/images/fastpaybanner 2.png'
                        alt='logo'
                      />
                    </motion.div>
                  </div>
                </>
              ) : null}
            </div>
          )}
        </div>)
      },[newNavigation, enableUsioEnrollment, ActiveStep])
         
      
   
  );
    {/* <div>
      <StyledList
        className={clsx(
          'navigation whitespace-nowrap px-12',
          `active-${active}-list`,
          dense && 'dense',
          className
        )}
      >
        {newNavigation.map((_item) => (
          <>
            {_item.tooltip ? (
              <div key={_item.id} style={{ position: 'relative' }}>
                <FuseNavItem
                  key={_item.id}
                  type={`vertical-${_item.type}`}
                  item={_item}
                  nestedLevel={0}
                  onItemClick={handleItemClick}
                  request_load={request_load}
                />
                <HtmlTooltip
                  title={_item.tooltip}
                  style={{ position: 'absolute', right: 0, top: 0 }}
                >
                  <IconButton>
                    <InfoOutlinedIcon sx={{ color: 'black' }} />
                  </IconButton>
                </HtmlTooltip>

                {_item.id == 'subcontractors-new' && counterSub > 0 && (
                  <IconButton style={{ position: 'absolute', right: 25, top: 3 }}>
                    <div className='item-badge px-3 bg-black text-white rounded-full text-xs'>
                      {counterSub}
                    </div>
                  </IconButton>
                )}

                {_item.id == 'owner-operators' && counterOwner > 0 && (
                  <IconButton style={{ position: 'absolute', right: 25, top: 3 }}>
                    <div className='item-badge px-3 bg-black text-white rounded-full text-xs'>
                      {counterOwner}
                    </div>
                  </IconButton>
                )}

                {_item.id == 'dispatch' && (
                  <span
                    className='item-badge bg-black text-xs  rounded-full px-2 py-1'
                    style={{
                      position: 'absolute',
                      right: 118,
                      top: 18,
                      color: '#edca33',
                      paddingLeft: '5px',
                      paddingRight: '5px',
                    }}
                  >
                    Beta
                  </span>
                )}

                {_item.id == 'agent' && (
                  <span
                    className='item-badge bg-black text-xs  rounded-full px-2 py-1'
                    style={{
                      position: 'absolute',
                      right: 118,
                      top: 18,
                      color: '#edca33',
                      paddingLeft: '5px',
                      paddingRight: '5px',
                    }}
                  >
                    Beta
                  </span>
                )}
              </div>
            ) : (
              <>
                <div style={{ position: 'relative' }}>
                  <FuseNavItem
                    key={_item.id}
                    type={`vertical-${_item.type}`}
                    item={_item}
                    nestedLevel={0}
                    onItemClick={handleItemClick}
                    request_load={request_load}
                  />
                  {_item.id == 'driverlist' && counterDriver > 0 && (
                    <IconButton style={{ position: 'absolute', right: 25, top: 3 }}>
                      <div className='item-badge px-3 bg-black text-white rounded-full text-xs'>
                        {counterDriver}
                      </div>
                    </IconButton>
                  )}

                  {_item.id == 'stafflist' && counterUser > 0 && (
                    <IconButton style={{ position: 'absolute', right: 25, top: 3 }}>
                      <div className='item-badge px-3 bg-black text-white rounded-full text-xs'>
                        {counterUser}
                      </div>
                    </IconButton>
                  )}

                  {_item.id == 'dispatch' && (
                    <span
                      className='item-badge bg-black text-xs  rounded-full px-2 py-1'
                      style={{
                        position: 'absolute',
                        right: 134,
                        top: 18,
                        color: '#edca33',
                        paddingLeft: '5px',
                        paddingRight: '5px',
                      }}
                    >
                      Beta
                    </span>
                  )}

                  {_item.id == 'agent' && (
                    <span
                      className='item-badge bg-black text-xs  rounded-full px-2 py-1'
                      style={{
                        position: 'absolute',
                        right: 118,
                        top: 18,
                        color: '#edca33',
                        paddingLeft: '5px',
                        paddingRight: '5px',
                      }}
                    >
                      Beta
                    </span>
                  )}
                </div>
              </>
            )}
          </>
        ))}
      </StyledList>

      {user?.user_type != 'super-admin' && hasPermission(PERMISSION_MODEL.fastPayAccess) && (
        <div className='flex flex-col items-center'>
          {hidden ? (
            <Grid className='flex flex-grow  justify-center'>
              <Paper
                style={{
                  marginTop: '20px',
                  padding: '16px',
                  textAlign: 'center',
                  minHeight: '100px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                  borderRadius: '0',
                  backgroundColor: 'transparent', // Fondo transparente
                  border: '1px solid #000', // Borde negro de 1px, ajusta el color como prefieras
                }}
              >
                <Typography variant='h6'>FREE TRIAL ENDS IN</Typography>
                <Typography
                  variant='h2'
                  style={{
                    color: '#FFD700',
                    fontWeight: 'bold',
                    fontSize: '4rem',
                  }}
                >
                  {daysRemaining}
                </Typography>
                <Typography variant='body2'>DAYS</Typography>
                <Button
                  variant='contained'
                  style={{
                    backgroundColor: '#000',
                    color: '#FFF',
                    '&:hover': {
                      backgroundColor: '#333',
                    },
                  }}
                  onClick={() => {
                    managePaymentMethods();
                  }}
                >
                  Update Billing Details
                </Button>
              </Paper>
            </Grid>
          ) : null}

          {enableUsioEnrollment && ActiveStep != 8 ? (
            <>
              <div className='flex pt-40 pb-40'>
                <motion.div variants={item} className='flex flex-row items-center justify-center'>
                  <img
                    onClick={dwollaClick}
                    className='w-4/6 items-center cursor-pointer'
                    src='assets/images/fastpaybanner 2.png'
                    alt='logo'
                  />
                </motion.div>
              </div>
            </>
          ) : null}
        </div>
      )}
    </div> */}
  
}

injectReducer('loadz_auth', AuthReducer);
injectReducer('loadz_jobs', JobReducer);

const mapDispatchToProps = (dispatch) => ({
  getPendingJobs: (payload, onError) => dispatch(JobAction.getPendingJobs(payload, onError)),
  getBolPendingCount: (payload, onError) =>
    dispatch(JobAction.getBolPendingCount(payload, onError)),
});

const mapStateToProps = (state) => {
  const reqState = state?.['requests/request'] || state?.requests;
  const reqList = reqState?.request || [];
  const dispList = reqState?.disp_requests || [];
  const cloneList = reqState?.clone_requests || [];
  const navRequestCount =
    (reqList.filter((r) => !r.resolved)?.length || 0) +
    (dispList.filter((r) => !r.resolved)?.length || 0) +
    (cloneList.filter((r) => !r.resolved)?.length || 0);
  return {
    company: state?.loadz_auth?.AuthReducer?.user?.company,
    user: state?.loadz_auth?.AuthReducer?.user,
    pending_jobs_count: state.loadz_jobs?.JobReducer?.pending_count,
    bol_pending_count: state.loadz_jobs?.JobReducer?.bol_pending_count,
    navRequestCount,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FuseNavVerticalLayout1);
